import { render, staticRenderFns } from "./AddPatent.vue?vue&type=template&id=2467543e&scoped=true"
import script from "./AddPatent.vue?vue&type=script&lang=ts"
export * from "./AddPatent.vue?vue&type=script&lang=ts"
import style0 from "./AddPatent.vue?vue&type=style&index=0&id=2467543e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467543e",
  null
  
)

export default component.exports